import React, { useState } from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Form,
	Row,
} from "reactstrap";

import formNavigationUtils from "../utils/formNavigationUtils";
import FormattedMaskInput from "../components/formattedMaskInput/FormattedMaskInput";
import InputElement from "../features/forms/components/InputElement";

import { failAlert, successAlertCustom } from "../utils/alertUtils";
import { useDigitzsMerchantId } from "../stores/LocalStorageHelper";
import { SelectorElement } from "../features/forms/components/InputElement";

import { yupResolver } from "@hookform/resolvers";
import { FormProvider, useForm } from "react-hook-form";
import useSetAccount from "./useSetAccount";
import useSetDeal from "../features/deal/hooks/useSetDeal";
import * as yup from "yup";
import { addBankToAccount } from "../api/AutopayApi";

const AchPaymentMethod = ({
	dmsCustomerId,
	// relation ot other tables
	accountID = null,
	toggle,
}) => {
	const merchantId = useDigitzsMerchantId();
	const setAccount = useSetAccount();
	const setDeal = useSetDeal();
	const [accountType, setAccountType] = useState("checking");
	const [accountName, setAccountName] = useState("");
	const [accountNumber, setAccountNumber] = useState(null);
	const [routingNumber, setRoutingNumber] = useState(null);

	// Calls api to process payment if all data is valid
	const processPayment = () => {
		if (merchantId !== null) {
			const paymentData = {
				accountID,
				bank: {
					// if you also want to set the DB customer FK:
					dmsCustomerId: dmsCustomerId,

					accountType,
					accountName,
					accountNumber,
					routingNumber,
					country: "US",
					label:
						accountNumber.substring(accountNumber.length - 4) +
						"_" +
						accountName,
				},
			};

			addBankToAccount(paymentData).then(
				(res) => {
					successAlertCustom(res.data.message);
					toggle();
				},
				(err) => {
					// setShowPaymentProgress(false);
					failAlert(err?.response?.data?.message || "Failed to process");
				}
			);
		} else {
		}
	};
	// Define rules for each input field
	const schema = yup.object().shape({
		accountType: yup.string().required("Account type is required"),
		digitzsAccountName: yup.string().required("Name on account is required"),
		// digitzsAccountNumber: yup
		// 	.string()
		// 	.matches(/^\d+$/, "Must be numeric")
		// 	.required("Account number is required"),
		// digitzsRoutingNumber: yup
		// 	.string()
		// 	.matches(/^\d{9}$/, "Must be 9 digits")
		// 	.required("Routing number is required"),
	});
	// Define form validation parameters
	const methods = useForm({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
		shouldFocusError: true,
	});

	return (
		<div className="col-lg-12 mx-auto">
			<FormProvider {...methods}>
				<Form onKeyDown={formNavigationUtils}>
					<Card className="pt-2">
						<CardHeader>
							<CardTitle>
								<h3>Setup ACH Method</h3>
							</CardTitle>
						</CardHeader>
						<div>
							<CardBody className="mx-1">
								<Row>
									<SelectorElement
										{...methods}
										name="accountType"
										label="Account Type"
										value={accountType}
										onChange={(e) => setAccountType(e.target.value)}
										options={[
											{ value: "checking", label: "Checking" },
											{ value: "savings", label: "Savings" },
										]}
										labelClass="required"
									/>
									<InputElement
										{...methods}
										colSize="col-lg-3"
										value={accountName}
										onChange={(e) => setAccountName(e.target.value)}
										name="digitzsAccountName"
										label="Name on Account"
										placeholder=""
										type="text"
									/>
									<FormattedMaskInput
										{...methods}
										colSize="col-lg-4"
										format="##########"
										value={accountNumber}
										onChange={setAccountNumber}
										name="digitzsAccountNumber"
										label="Account Number"
									/>
									<FormattedMaskInput
										{...methods}
										colSize="col-lg-4"
										format="##########"
										value={routingNumber}
										onChange={setRoutingNumber}
										name="digitzsRoutingNumber"
										label="Routing Number"
									/>
								</Row>
							</CardBody>
							<CardBody className="row mx-1 mt-3">
								<div className="col-12 d-flex justify-content-center my-3">
									<Button
										color="primary"
										onClick={methods.handleSubmit(processPayment)}
									>
										Save Payment Method
									</Button>
								</div>
							</CardBody>
						</div>
					</Card>
				</Form>
			</FormProvider>
		</div>
	);
};

export default AchPaymentMethod;
